import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export default function Breadcrumbs({ crumbs = [] }) {
  return (
    <nav className="flex items-center gap-1 text-sm text-slate-500" aria-label="Breadcrumb">
      <Link to="/files" className="flex items-center gap-1 hover:text-brand-600">
        <Home className="h-4 w-4" />
        <span>Home</span>
      </Link>
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <span key={crumb.id} className="flex items-center gap-1">
            <ChevronRight className="h-4 w-4 text-slate-300" />
            {isLast ? (
              <span className="font-medium text-slate-700">{crumb.name}</span>
            ) : (
              <Link to={`/folder/${crumb.id}`} className="hover:text-brand-600">
                {crumb.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
